<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M9,9C9,9,5,9,5,9C4.45,9,4,9.45,4,10C4,10,4,13,4,13C4,13.55,4.45,14,5,14C5,14,9,14,9,14C9.55,14,10,13.55,10,13C10,13,10,10,10,10C10,9.45,9.55,9,9,9C9,9,9,9,9,9ZM1,0C0.45,0,0,0.45,0,1C0,1,0,15,0,15C0,15.55,0.45,16,1,16C1.55,16,2,15.55,2,15C2,15,2,1,2,1C2,0.45,1.55,0,1,0C1,0,1,0,1,0ZM14,2C14,2,5,2,5,2C4.45,2,4,2.45,4,3C4,3,4,6,4,6C4,6.55,4.45,7,5,7C5,7,14,7,14,7C14.55,7,15,6.55,15,6C15,6,15,3,15,3C15,2.45,14.55,2,14,2C14,2,14,2,14,2Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'AlignmentLeft',
} as DefineComponent
</script>
